export const POST_SIGN_UP_DATA = "post_sign_up_data";
export const USER_LOGIN_INFO = "user_login_info";
export const IS_USER_ADMIN = "is_user_admin";

export const CLICK_TO_OPEN_SIDEBAR = "click_to_open_sidebar";
export const MODAL_TOGGLE = "modal-toggle";
export const IS_LOGIN_PAGE = "is_login_page";
export const LOADING_SPINNER = "loading_spinner";
export const LOADING_SPINNER_FOR_BLOG_DETAILS =
  "loading_spinner_for_blog_details";
export const LOADING_SPINNER_FOR_UPDATE_BLOGS =
  "loading_spinner_for_update_blogs";

export const UPDATE_BLOGS_DATA_AFTER_UPLOAD_NEW_BLOGS =
  "update_blogs_data_after_upload_new_blogs";
export const GET_ALL_BLOGS_INFO = "get_all_blogs_info";
export const GET_ONE_BLOG_DETAILS = "get_one_blog_details";
export const UPDATE_BLOGS_DATA_AFTER_DELETE = "update_blogs_data_after_delete";
export const UPDATE_BLOGS_WHEN_ANY_ITEM_WILL_UPDATED =
  "update_blogs_when_any_item_will_update";
export const UPDATE_BLOG_DETAILS = "update_blog_details";
export const UPDATE_BLOGS_WHEN_ANY_LIKE_INSERT =
  "update_blogs_when_any_like_insert";
